import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Star } from "lucide-react";

const LABELS = ["", "Mala", "Regular", "Bien", "Muy bien", "Excelente"];

export const StarRating = ({ selected, onSelect, starColor = "#EAB308" }) => {
  const [hovered, setHovered] = useState(0);
  const active = hovered || selected || 0;

  return (
    <div className="flex flex-col items-center gap-4" data-testid="star-rating-group">
      <div
        className="flex items-center gap-2.5 sm:gap-3.5"
        onMouseLeave={() => setHovered(0)}
      >
        {[1, 2, 3, 4, 5].map((value) => {
          const isActive = value <= active;
          return (
            <motion.button
              key={value}
              type="button"
              data-testid={`star-rating-${value}`}
              aria-label={`${value} estrella${value > 1 ? "s" : ""} — ${LABELS[value]}`}
              onMouseEnter={() => setHovered(value)}
              onClick={() => onSelect(value)}
              whileHover={{ scale: 1.18, rotate: -6 }}
              whileTap={{ scale: 0.88 }}
              animate={
                selected && value <= selected
                  ? { scale: [1, 1.35, 1], rotate: [0, -10, 8, 0] }
                  : { scale: 1, rotate: 0 }
              }
              transition={{ type: "spring", stiffness: 400, damping: 17 }}
              className="rounded-full p-1.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--brand-accent)] focus-visible:ring-offset-2 focus-visible:ring-offset-[#FDFBF7] cursor-pointer"
            >
              <Star
                className="h-12 w-12 sm:h-14 sm:w-14 transition-colors duration-150 drop-shadow-sm"
                strokeWidth={1.4}
                fill={isActive ? starColor : "transparent"}
                color={isActive ? starColor : "#E7E5E4"}
              />
            </motion.button>
          );
        })}
      </div>
      <div className="h-5">
        <AnimatePresence mode="wait">
          {active > 0 && (
            <motion.span
              key={active}
              initial={{ opacity: 0, y: 6 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -6 }}
              transition={{ duration: 0.18 }}
              data-testid="star-rating-label"
              className="font-mono-label text-xs uppercase tracking-[0.25em] text-[#B38D46]"
            >
              {LABELS[active]}
            </motion.span>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
};
